var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasPower)?_c('div',[_vm._t("default")],2):_c('div',[_vm._v("抱歉，你没有权限访问")])])
}
var staticRenderFns = []

export { render, staticRenderFns }